<template>
  <div
    class="sc-container-grid"
    :class="{
      'loan-details-tile-hidden': !showApplicationInfoTile,
      'todo-list-tile-hidden': !showTodoListTile,
      'file-upload-tile-hidden': !showApplicationFileUpload,
    }"
  >
    <div class="loan-details-tile">
      <application-info
        v-if="showApplicationInfoTile"
        :application="appData.application"
        :applicant="appData.currentApplicant"
        @complete="$emit('stepComplete')"
        @hydrateStore="$emit('hydrateStore')"
      />
    </div>
    <div class="application-status-tile">
      <application-status @viewCertificationUpdates="emit('viewCertificationUpdates')" />
    </div>
    <div class="todo-list-tile">
      <application-checklist
        v-if="showTodoListTile"
        :application="appData.application"
        :applicant="appData.currentApplicant"
        @hydrateStore="$emit('hydrateStore')"
      />
    </div>
    <div class="file-upload-tile">
      <application-file-upload
        v-if="showApplicationFileUpload"
        :application="appData.application"
        :applicant="appData.currentApplicant"
      />
      <application-reapply />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import ApplicationInfo from "@/components/ApplicationInfo.vue";
import ApplicationStatus from "@/components/ApplicationStatus.vue";
import ApplicationChecklist from "@/components/ApplicationChecklist.vue";
import ApplicationFileUpload from "@/components/ApplicationFileUpload.vue";
import ApplicationReapply from "@/components/shared/ApplicationReapply.vue";

const store = useStore();

const emit = defineEmits<{
  (e: "stepComplete"): void;
  (e: "hydrateStore"): void;
  (e: "viewCertificationUpdates"): void;
}>();

const props = defineProps({
  showApplicationInfoTile: { type: Boolean, required: true },
  showApplicationFileUpload: { type: Boolean, required: true },
  showTodoListTile: { type: Boolean, required: true },
});

const appData = computed(() => store.state?.appData);
</script>

<style>
.loan-details-tile .tile {
  margin: 0;
}

@media (max-width: 992px) {
  .loan-details-tile .tile {
    margin: 0 0 1.5rem 0;
  }
}
</style>
<style scoped>
.sc-container-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 1rem;
  padding: 10px;
}

.loan-details-tile {
  grid-row: 1 / span 1;
  grid-column: 1 / span 3;
}
.file-upload-tile {
  grid-row: 2 / span 2;
  grid-column: 1 / span 3;
}
.reapply-tile {
  grid-row: 3 / span 3;
  grid-column: 1 / span 3;
}

.application-status-tile {
  grid-row: 1 / span 2;
  grid-column: 4 / span 5;
}

.todo-list-tile {
  grid-row: 1 / span 2;
  grid-column: 9 / span 4;
}

.sc-container-grid.loan-details-tile-hidden.file-upload-tile {
  grid-row: 1 / span 2;
  grid-column: 1 / span 3;
}

.sc-container-grid.todo-list-tile-hidden .application-status-tile {
  grid-column: 4 / span 10;
}

.sc-container-grid.loan-details-tile-hidden .file-upload-tile {
  grid-row: 1 / span 2;
  grid-column: 1 / span 3;
}

.sc-container-grid.loan-details-tile-hidden .reapply-tile {
  grid-row: 1 / span 2;
  grid-column: 1 / span 3;
}

.sc-container-grid.loan-details-tile-hidden.todo-list-tile-hidden.file-upload-tile-hidden
  .application-status-tile
  .reapply-tile-hidden {
  grid-row: 1 / span 1;
  grid-column: 1 / span 9;
}

@media (max-width: 992px) {
  .sc-container-grid {
    display: block;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    grid-gap: 0rem;
    row-gap: 0rem;
  }
  .loan-details-tile {
    grid-row: 1 / span 1;
    grid-column: 1 / span 1;
    height: fit-content;
  }

  .file-upload-tile {
    grid-row: 4 / span 1;
    grid-column: 1 / span 1;
    height: fit-content;
  }

  .application-status-tile {
    grid-row: 2 / span 1;
    grid-column: 1 / span 1;
    height: fit-content;
  }

  .todo-list-tile {
    height: fit-content;
    grid-row: 3 / span 1;
    grid-column: 1 / span 1;
  }

  .reapply-tile {
    grid-row: 1 / span 1;
    grid-column: 1 / span 1;
    height: fit-content;
  }
}
</style>
